"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_pick_1 = __importDefault(require("lodash.pick"));
var _kernel_store_types_1 = require("../../types");
var _kernel_container_1 = __importDefault(require("../../../container"));
var RateLimiting_1 = __importDefault(require("../RateLimiting"));
var PointService = (function () {
    function PointService() {
    }
    PointService.sendPlayState = function (playState) {
        return __awaiter(this, void 0, void 0, function () {
            var settings, request, backendPlayState, hardwareInfo, status, osVersion;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        settings = _kernel_container_1.default.get("SETTINGS");
                        request = _kernel_container_1.default.get("REQUEST");
                        backendPlayState = playState === _kernel_store_types_1.EPlayState.PLAY ? "play" : "stop";
                        return [4, settings.getHardwareInfo()];
                    case 1:
                        hardwareInfo = _a.sent();
                        if (hardwareInfo) {
                            osVersion = "".concat(hardwareInfo.os.type, "-").concat(hardwareInfo.os.arch, "-").concat(hardwareInfo.os.version);
                            status = {
                                state: backendPlayState,
                                currentVersion: settings.getSetting("APP_VERSION"),
                                updateChannel: settings.getSetting("APP_UPDATE_CHANNEL"),
                                hostname: hardwareInfo.hostname,
                                osVersion: osVersion,
                                mmIdentifier: hardwareInfo.mmIdentifier,
                                ipAddress: hardwareInfo.ipAddress,
                                macAddress: hardwareInfo.macAddress,
                            };
                        }
                        else {
                            status = {
                                state: backendPlayState,
                                currentVersion: settings.getSetting("APP_VERSION"),
                                updateChannel: settings.getSetting("APP_UPDATE_CHANNEL"),
                            };
                        }
                        return [4, request.sendPlaybackState(status)];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    PointService.getDeviceData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = _kernel_container_1.default.get("REQUEST");
                        return [4, request.getDeviceData()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    PointService.getDeviceOptions = function (data) {
        var _a;
        return {
            pointId: (_a = data.device.point) === null || _a === void 0 ? void 0 : _a.id,
            debugMode: data.device.debugMode,
            logLevel: data.device.logLevel,
            bindingCode: data.device.bindingCode,
        };
    };
    PointService.getPointData = function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23;
        if (!((_a = data.device.point) === null || _a === void 0 ? void 0 : _a.id))
            return null;
        var settings = _kernel_container_1.default.get("SETTINGS");
        var historyDefaultBatchSize = settings.getSetting("HISTORY_DEFAULT_BATCH_SIZE", 50);
        var historyDefaultMaxItems = settings.getSetting("HISTORY_DEFAULT_MAX_ITEMS", 12000);
        return {
            id: (_c = (_b = data.device.point) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : 0,
            timezone: (_e = (_d = data.device.point) === null || _d === void 0 ? void 0 : _d.timezone) !== null && _e !== void 0 ? _e : "Europe/Moscow",
            volume: (_g = (_f = data.device.point) === null || _f === void 0 ? void 0 : _f.volume) !== null && _g !== void 0 ? _g : 100,
            address: (_j = (_h = data.device.point) === null || _h === void 0 ? void 0 : _h.address) !== null && _j !== void 0 ? _j : "",
            comment: (_l = (_k = data.device.point) === null || _k === void 0 ? void 0 : _k.comment) !== null && _l !== void 0 ? _l : "",
            periodicRestartTime: (_m = data.device.point.periodicRestartTime) !== null && _m !== void 0 ? _m : null,
            title: (_p = (_o = data.device.point) === null || _o === void 0 ? void 0 : _o.address) !== null && _p !== void 0 ? _p : "",
            isEnabled: (_r = (_q = data.device.point) === null || _q === void 0 ? void 0 : _q.isEnabled) !== null && _r !== void 0 ? _r : true,
            sleepMode: (_t = (_s = data.device.point) === null || _s === void 0 ? void 0 : _s.sleepMode) !== null && _t !== void 0 ? _t : false,
            cleanupPeriod: data.device.cleanupPeriod,
            historyBatchSize: (_u = data.device.historyBatchSize) !== null && _u !== void 0 ? _u : historyDefaultBatchSize,
            historyMaxItems: (_v = data.device.historyMaxItems) !== null && _v !== void 0 ? _v : historyDefaultMaxItems,
            sleepSettings: ((_w = data.device.point) === null || _w === void 0 ? void 0 : _w.sleepSettings)
                ? __spreadArray([], __read(data.device.point.sleepSettings.map(function (item) {
                    var option = (0, lodash_pick_1.default)(item, ["day", "start", "end"]);
                    return __assign(__assign({}, option), { day: (option.day - 1) });
                })), false) : null,
            rateLimitSettings: ((_y = (_x = data.device.point) === null || _x === void 0 ? void 0 : _x.speedLimitOptions) === null || _y === void 0 ? void 0 : _y.settings)
                ? data.device.point.speedLimitOptions.settings.map(function (setting) {
                    return {
                        start: setting.start,
                        end: setting.end,
                        limit: setting.speedValue,
                        days: RateLimiting_1.default.convertWeekDays(setting.weekdays),
                    };
                })
                : null,
            userId: (_1 = (_0 = (_z = data.device.point) === null || _z === void 0 ? void 0 : _z.user) === null || _0 === void 0 ? void 0 : _0.id) !== null && _1 !== void 0 ? _1 : null,
            userEmail: (_4 = (_3 = (_2 = data.device.point) === null || _2 === void 0 ? void 0 : _2.user) === null || _3 === void 0 ? void 0 : _3.email) !== null && _4 !== void 0 ? _4 : null,
            streamId: ((_6 = (_5 = data.device.point) === null || _5 === void 0 ? void 0 : _5.stream) === null || _6 === void 0 ? void 0 : _6.id) ? String((_8 = (_7 = data.device.point) === null || _7 === void 0 ? void 0 : _7.stream) === null || _8 === void 0 ? void 0 : _8.id) : null,
            streamTitle: (_12 = (_11 = (_10 = (_9 = data.device) === null || _9 === void 0 ? void 0 : _9.point) === null || _10 === void 0 ? void 0 : _10.stream) === null || _11 === void 0 ? void 0 : _11.title) !== null && _12 !== void 0 ? _12 : null,
            streamCover: ((_16 = (_15 = (_14 = (_13 = data.device) === null || _13 === void 0 ? void 0 : _13.point) === null || _14 === void 0 ? void 0 : _14.stream) === null || _15 === void 0 ? void 0 : _15.cover) === null || _16 === void 0 ? void 0 : _16.fullName) || null,
            searchTags: ((_19 = (_18 = (_17 = data.device) === null || _17 === void 0 ? void 0 : _17.point) === null || _18 === void 0 ? void 0 : _18.stream) === null || _19 === void 0 ? void 0 : _19.searchTags) || null,
            amplify: __assign({}, this.convertAmplifyOptions((_21 = (_20 = data.device.point) === null || _20 === void 0 ? void 0 : _20.amplifyPromo) !== null && _21 !== void 0 ? _21 : null, (_23 = (_22 = data.device.point) === null || _22 === void 0 ? void 0 : _22.amplifyMediafile) !== null && _23 !== void 0 ? _23 : null)),
            contentBlocks: [],
        };
    };
    PointService.convertAmplifyOptions = function (promo, mediafile) {
        if (!promo || !mediafile) {
            return {
                promo: 1,
                mediafile: 1,
            };
        }
        if (promo > 1 || mediafile > 1) {
            return {
                promo: 1,
                mediafile: 1,
            };
        }
        else {
            return {
                promo: promo,
                mediafile: mediafile,
            };
        }
    };
    return PointService;
}());
exports.default = PointService;
//# sourceMappingURL=index.js.map